var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.filterGroups),function(group){return _c('FilterGroup',{key:group.value,attrs:{"group":group,"is-collapsed":_vm.isGroupCollapsed(group.value)},on:{"select":_vm.onFilterGroupSelect},scopedSlots:_vm._u([{key:"filter",fn:function(ref){
var id = ref.id;
return [_c('FacetFilters',{attrs:{"group-id":id,"facets":group.facets},on:{"change":_vm.onChangeCategory}})]}}],null,true)})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }